import { UserRole } from "../common/permissions";
import { MetricType } from "./metrics/metricsType";

// Enums
export enum ModeratorOrderingField {
  USERNAME_ASC = "username",
  USERNAME_DESC = "-username",
  NAME_ASC = "name",
  NAME_DESC = "-name",
  CREATED_AT_ASC = "created_at",
  CREATED_AT_DESC = "-created_at",
}

export enum ModeratorPermission {
  CAN_VIEW_USERS = "canViewUsers",
  CAN_BLOCK_USERS = "canBlockUsers",
  CAN_VIEW_ADS = "canViewAds",
  CAN_BLOCK_ADS = "canBlockAds",
  CAN_APPROVE_ADS = "canApproveAds",
  CAN_VIEW_APPEALS = "canViewAppeals",
  CAN_REPLY_APPEALS = "canReplyAppeals",
  CAN_VIEW_PROPOSALS = "canViewProposals",
  CAN_VIEW_COMPLAINTS = "canViewComplaints",
  CAN_VIEW_DASHBOARD_METRICS = "canViewDashboardMetrics",
}

// Permission interface
export interface PermissionItem {
  key: ModeratorPermission;
  label: string;
}

export interface PermissionGroup {
  title: string;
  items: PermissionItem[];
}

// Request interface
export interface ModeratorsRequest {
  limit?: number;
  offset?: number;
  ordering?: ModeratorOrderingField;
  search?: string;
}

export interface CreateModeratorRequest {
  username: string;
  password: string;
  name: string;
  permissions: ModeratorPermissionsResponse;
}

export type MetricPermissionModel = Record<MetricType, boolean>;

// Response interfaces
export interface ModeratorPermissionsResponse {
  canViewUsers: boolean;
  canBlockUsers: boolean;
  canViewAds: boolean;
  canBlockAds: boolean;
  canApproveAds: boolean;
  canViewAppeals: boolean;
  canReplyAppeals: boolean;
  canViewProposals: boolean;
  canViewComplaints: boolean;
  canViewDashboardMetrics: boolean;
  metricsPermissions: MetricPermissionModel;
}

export interface ModeratorResponse {
  id: string;
  createdAt: string;
  username: string;
  password: string;
  name: string;
  role: UserRole;
  permissions: ModeratorPermissionsResponse;
}
